export enum OrderStatusEnum {
  Unpaid = 'unpaid',
  Paid = 'paid',
  InProgress = 'in_progress',
  Closed = 'closed',
}
